/* Display formatting for values the API sends in raw units. */

const inr = new Intl.NumberFormat("en-IN");

// 25000 → "₹250"
export const formatRupees = (paise) => `₹${inr.format(Math.round(paise / 100))}`;

// 25000 → "₹250 for two"
export const formatCostForTwo = (paise) =>
  paise == null ? null : `${formatRupees(paise)} for two`;

// (20, 25) → "20-25 mins"; one bound only → "25 mins"
export function formatDeliveryWindow(min, max, estimate) {
  if (min != null && max != null) return min === max ? `${min} mins` : `${min}-${max} mins`;
  const single = estimate ?? min ?? max;
  return single == null ? null : `${single} mins`;
}

// 10000 → "10K+", 500 → "500+": the API sends the lower bound of a bucket
export function formatRatingCount(count) {
  if (count == null) return null;
  if (count >= 1000) return `${Math.floor(count / 1000)}K+`;
  return `${count}+`;
}
